{
  "app_name": "Impact Golf",
  "app_banner_copy": "Spela smidigare med mobilappen",
  "app_banner_install": "Installera",
  "app_banner_dismiss": "Stäng",
  "app_profile_row": "Ladda ner mobilappen",
  "app_store_ios": "App Store",
  "app_store_android": "Google Play",
  "app_platform_ios": "iPhone",
  "app_platform_android": "Android"
}
